<template>
  <header class="top">
    <div class="header-area ptb-18 header-sticky">
      <div class="container">
        <div class="row">
          <div class="col-md-2 col-xs-12">
            <div class="logo">
              <a href="/"
                ><img src="../assets/img/logo/logo.png" alt="COFFEE"
              /></a>
            </div>
          </div>
          <div class="col-md-8 col-xs-12">
            <div class="content-wrapper">
              <!-- Main Menu Start -->
              <div class="main-menu text-center">
                <nav>
                  <ul>
                    <li><a href="/">Home</a></li>
                    <li><a href="/about">About us</a></li>
                    <li><a href="/class">classes</a></li>
                    <li><a href="/gallery">gallery</a></li>
                    <li><a href="/contact">Contact</a></li>
                  </ul>
                </nav>
              </div>
              <div class="mobile-menu hidden-lg hidden-md"></div>
              <!-- Main Menu End -->
            </div>
          </div>
          <div class="col-md-2 hidden-sm hidden-xs">
            <div class="header-contact text-right">
              <a class="banner-btn" data-text="Login" href="/login"
                ><span>Login</span></a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { mapGetters } from "vuex";
// import constants from "../modules/constants";
export default {
  data: () => {
    return {
      visibleModal: null,
      totalQty: 0
    };
  },
  computed: {
    ...mapGetters({
      products: "getCart",
      user: "getUser",
      currentDashboardSubscription: "getCurrentDashboardSubscription"
    })
  },
  mounted() {
    // this.totalQty = 0;
    // for (let i = 0; i < this.products.length; i++) {
    // 	this.totalQty += parseInt(this.products[i].qty);
    // }
  },
  // watch: {
  // 	products: {
  // 		deep: true,
  // 		handler(val, oldVal) {
  // 			this.totalQty = 0;
  // 			console.log('new p length:', this.products.length);
  // 			for (let i = 0; i < this.products.length; i++) {
  // 				this.totalQty += parseInt(this.products[i].qty);
  // 			}
  // 		}
  // 	}
  // },
  methods: {
    onModalHide() {
      this.visibleModal = null;
    },
    toggleNavbar() {
      this.$refs.navbarToggle.$el.click();
    },
    quantify(qty) {
      if (qty > 99) {
        return "99+";
      } else {
        return qty;
      }
    }
  }
};
</script>
<style>
.dropdown-toggle::after {
  color: #fff !important;
}
#masthead .nav-link img {
  opacity: 100;
}
.navbar-collapse.in {
  overflow-y: visible !important;
}
.nav_bar_add {
  margin-left: 100px;
  padding-top: 10px;
  padding-bottom: 10px;
}
.menu-new {
  margin-left: 200px;
}
@media (max-width: 767px) {
  .menu-new {
    margin-left: 10px !important;
  }
  .container {
    max-width: 920px !important;
  }
}
@media (max-width: 990px) {
  .menu-new {
    margin-left: 10px !important;
  }
  .container {
    max-width: 920px !important;
  }
}
@media only screen and (max-width: 884px) {
  .menu-new {
    margin-left: 10px !important;
  }
}
@media (max-width: 1200px) {
  .menu-new {
    margin-left: 50px !important;
  }
}
/* @media (max-width: 767px) {
  .menu-new {
    margin-left: 300px !important;
  }
} */
@media (max-width: 1200px) {
  .nav_bar_add {
    margin-left: 0px !important;
  }
}
/* @media (max-width: 990px) {
  /* .navbar-header {
    float: none;
  }
  .navbar-toggle {
    display: block;
  }
  .navbar-collapse {
    border-top: 1px solid transparent;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.1);
  }
  .navbar-collapse.collapse {
    display: none !important;
  }
  .navbar-nav {
    float: none !important;
    margin: 7.5px -15px;
  }
  .navbar-nav > li {
    float: none;
  }
  .navbar-nav > li > a {
    padding-top: 10px;
    padding-bottom: 10px;
  }
  .collapse.in {
    display: block !important;
    float: left;
    width: 100%;
  } 
} */
</style>
